<template>
  <div :class="{ 'club-logo': true, 'selected-team-logo': isSelected }">
    <img
      :src="logoUrl"
      style="background-color: white; object-fit: contain; width: 100%; filter: opacity(.5)"
    />
  </div>
</template>

<script>
import { toRefs, computed } from 'vue';
export default {
  props: ['team', 'selected', 'competitionId'],
  setup(props) {
    const { selected } = toRefs(props);
    const isSelected = selected ? computed(() => selected.value === true ) : false;
    return {
      get: _.get,
      isSelected,
    }
  },
  computed: {
    clubPlaceholder() {
      return process.env.VUE_APP_PLACEHOLDER;
    },
    logoUrl() {
      console.log('logoUrl', this.team, this.competitionId);
      const teamLogo = this.get(this.team, 'meta.imgUrl');
      const competitionLogo = this.get(this.competitionId, 'meta.imgUrl');

      return teamLogo || competitionLogo || this.clubPlaceholder;
    }
  },
};
</script>

<style scoped lang="scss">
.club-logo {
  width: 4.25rem;
  height: 4.25rem;
  border: 2px solid rgba(226, 9, 9, 0.1);
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.1s ease-in-out;
}

.selected-team-logo {
  // border: 2px solid rgb(234, 68, 68, 0.7);
  border: 2px solid rgba($secondary, .5);
  transform: scale(1.05);
  animation: at-ripple-pink 2s linear infinite;
}

.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@-webkit-keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
  }
  100% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
  }
}

@keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
  }
  100% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
  }
}



</style>